// All Routes
export const loginRoute = `/login`;
export const signUpRoute = `/invites/verify-invite`;
export const usersRoute = `/users`;
export const rolesRoute = `/roles`;
export const memberReportRoute = `/member-reports`;
export const memberTransactionsReportRoute = `/member-transactions-report`;
export const offerTransactionsReportRoute = `/offer-transactions-report`;
export const offerReportRoute = `/offer-reports`;
export const loyalMembersRoute = `/loyalty-members`;
export const cardPrintJobsRoute = `/card-printing`;
export const memberDetailsRoute = `/member-details`;
export const bulkUpdateTiersRoute = `/bulk-update-tiers`;
export const inviteMembersRoute = `/invite-member`;
export const memberCardsRoute = `/member-cards`;
export const membershipTiersRoute = `/membership-tiers`;
export const updateTiersRoute = `/update-membership-tiers`;
export const viewTierMembers = `/view-tier-members`;
export const createCardRoute = `/create-card`;
export const eventsRoute = `/events`;
export const projectsRoute = `/projects`;
export const retailorVendorRoute = `/stores`;
export const userGroupsRoute = `/user-groups`;
export const offerCatalogRoute = `/offers`;
export const pushNotificationRoute = `/push-notifications`;
export const advertisingRoute = `/advertising`;
export const dashboardRoute = `/`;
export const forgotPasswordRoute = `/forgotPassword`;
export const resetPasswordRoute = `/reset-password`;
export const OTPVerifyRoute = `/otp-verification`;
export const createUserRoute = `/create-user`;
export const modifyRolesRoute = `/update-roles`;
export const createProjectRoute = `/create-project`;
export const createGroupRoute = `/update-groups`;
export const groupAddRoute = `/add-to-group`;
export const projectAddRoute = `/add-to-project`;
export const editProfile = `/edit-profile`;
export const changePassword = `/change-password`;
export const createMembersBulk = `/create-members-csv`;
export const createOfferRoute = `/update-offers`;
export const createVendorRoute = `/update-stores`;
export const vendorBulkUpdateRoute = `/vendor-bulk-update`;
export const createCampaignRoute = `/update-campaigns`;
export const createEventRoute = `/update-events`;
export const createNotificationsRoute = `/create-notifications`;
export const moderationRoute = `/moderation-requests`;
export const moderationHistoryRoute = `/moderation-history`;
export const clientRoute = `/clients`;
export const createClient = `/invite-client`;
export const selectPlanRoute = `/subscription-plans`;
export const checkoutFormRoute = `/checkout`;
export const myPlanRoute = `/my-plan`;
export const myPaymentsRout = `/payments`;
export const plansRoute = `/plans`;

// CMS Routes
export const cmsRoute = `/cms`;